/**
 *  returns the current UTC timestamp in seconds
 */
export function currentTimestamp(): number {
    const now = new Date()
    return Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds()) / 1000
}

/**
 *  returns the minutes from a timestamp
 *  eg: timestamp 1651067100 (27 april 2022 13:45 UTC) returns 13 * 60 + 45 = 1345
 */
export function getTimeFromTimestamp(timestamp: number): number {
    const date = new Date(timestamp * 1000)
    return date.getHours() * 3600 + date.getMinutes() * 60 + date.getSeconds()
}

/**
 *  formats timestamp to date & time
 *  format (optional) can be used to select which time element needs to be displayed
 *  eg: format "dt" : date & time
*/
export function formatTimestamp(timestamp: number, format = "dt"): string {
    const date = new Date(timestamp * 1000)

    let output = ""
    if (format.includes("d")) {
        const day = date.getDate().toString().padStart(2, "0")
        const month = (date.getMonth() + 1).toString().padStart(2, "0")
        const year = date.getFullYear()
        output += day + "/" + month + "/" + year
    }
    if (format.includes("t")) {
        const hour = date.getHours().toString().padStart(2, "0")
        const minutes = date.getMinutes().toString().padStart(2, "0")
        if (output !== "") {
            output += " "
        }
        output += hour + ":" + minutes
    }
    return output
}

/**
 *  formats time (in seconds) to hh:mm:ss
 *  format (optional) can be used to select which time element needs to be displayed
 *  eg: format "hms" : hour, minutes & seconds or "ms" : minutes & seconds
 */
export function formatTime(time: number, format = "hms"): string {
    const data: any = {}
    data.h = Math.floor(time / 3600)
    time %= 3600
    data.m = Math.floor(time / 60)
    data.s = time % 60

    let output = ""
    for (const key in data) {
        if (format.includes(key)) {
            if (output !== "") {
                output += ":"
            }
            const value = data[key]
            output += value.toString().padStart(2, "0")
        }
    }

    return output
}

/**
    are 2 dates on the same day
*/
export function areDatesEqual(date1: Date | number, date2: Date | number): boolean {
    const d1 = date1 instanceof Date ? date1 : new Date(date1 * 1000)
    const d2 = date2 instanceof Date ? date2 : new Date(date2 * 1000)
    return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate()
}

/**
 * parses a time string (hh:mm:ss) to seconds
 */
export function parseTimeString(time: string): number {
    const parts = time.split(":")
    let seconds = 0
    for (let i = 0; i < parts.length; i++) {
        seconds += parseInt(parts[i]) * Math.pow(60, 2 - i)
    }
    return seconds
}
